{{#with parametersHandle}}
function automatic void add_parameters_to_config_db(string inst_name);
  {{ type }} {{ name }} = {{ type }}::type_id::create("{{ name }}");
{{#each ../parametersSetToConfigDb}}
  {{ ../identifier }}.{{ setterName }}({{ name }});
{{/each}}
  uvm_config_db#({{ type }})::set(null, inst_name, "{{ configDbKey }}", {{ identifier }});
endfunction
{{/with}}
